module.exports = __webpack_public_path__ + "img/Group 65.f0dc5c89.png";